module.exports = __webpack_public_path__ + "img/1163.028e11bf.gif";